module.exports = __webpack_public_path__ + "img/italyservices-v.c9077626.svg";